<template>
  <div class="main">
    <ul id="deskmeun">
      <li v-if="now == '/desk0'">我的工作台</li>
      <li
        :class="{ active: item.path == now }"
        @click="pages(item)"
        v-for="(item, index) in items"
        :key="index"
      >
        {{ item.name }}
      </li>
      <li style="margin-left: auto; margin-right: 0">{{ day }}</li>
    </ul>
    <desk0 v-if="now == '/desk0'"></desk0>
    <desk1 v-if="now == '/desk1'"></desk1>
  </div>
</template>
<script>
import desk0 from "./nodata";
import desk1 from "./allData";
var t;
export default {
  components: { desk0, desk1 },
  data() {
    return {
      items: [],
      now: "/desk0",
      day: 0,
    };
  },
  methods: {
    pages(row) {
      this.now = row.path;
    },
    getMenu() {
      var m = this.$store.state.nav;
      this.items.length = 0;
      for (let i = 0; i < m.length; i++) {
        if (m[i].name == "工作台") {
          for (let j = 0; j < m[i].childList.length; j++) {
            var t = m[i].childList[j];
            var obj = {
              name: t.name,
              path: t.link,
            };
            this.items.push(obj);
          }
        }
      }
      if (this.items.length > 0) {
        this.now = this.items[0].path;
      }
    },
  },
  computed: {
    nav() {
      this.getMenu();
    },
  },
  watch: {
    nav(m) {},
  },
  mounted() {
    setTimeout(() => {
      //this.getMenu();
    }, 500);

    t = setInterval(() => {
      this.day = this.utils.time(Date.now());
    }, 1000);
  },
  destroyed() {
    clearInterval(t);
  },
};
</script>
<style>
#deskmeun {
  display: flex;
  line-height: 40px;
  background: #fff;
  padding: 0 20px;
}
#deskmeun li {
  margin-right: 20px;
  cursor: pointer;
}
#deskmeun li.active {
  border-bottom: solid 2px #2996f5;
}
</style>


// WEBPACK FOOTER //
// src/components/workDesk/index.vue